import { render, staticRenderFns } from "./CookiesModal.vue?vue&type=template&id=144db564&scoped=true&"
import script from "./CookiesModal.vue?vue&type=script&lang=js&"
export * from "./CookiesModal.vue?vue&type=script&lang=js&"
import style0 from "./CookiesModal.vue?vue&type=style&index=0&id=144db564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144db564",
  null
  
)

export default component.exports